import MainNav from './main-nav';
import React from 'react';
import fallbackImage from '../../images/banner/banner-1.jpg';

const Header = (props) => {
    const { headerImage, headerTitle, headerIntro, showCTA } = props;
    const imageOrFallback = headerImage ? headerImage : fallbackImage;

    return (
        <header className="site-header">
            <a className="u-sr-only skip-to-content" href="#main-content">
                Skip to main content
            </a>
            <div className="banner-bg" style={{ backgroundImage: `url(${imageOrFallback})` }}></div>
            <MainNav />
            <div className="site-header__title">
                <div>
                    {headerTitle ? (
                        <h1 id="main-content" tabIndex="-1">
                            {headerTitle}
                        </h1>
                    ) : (
                        <h1 id="main-content" tabIndex="-1">
                            <span className="u-text-light">2020/21</span> Annual&nbsp;Report <span className="u-text-light">Summary</span>
                        </h1>
                    )}
                    <p>{headerIntro ? headerIntro : ''}</p>
                    {showCTA ? (
                        <a className="btn btn--primary" target="_blank" href="https://www.dfes.wa.gov.au/publications/Pages/annualreports.aspx">
                            Click here to view our full Annual Report 2020/21
                        </a>
                    ) : (
                        ''
                    )}
                </div>
            </div>
        </header>
    );
};

export default Header;
